import { BaseItemStore } from "../core/BaseStore";
import type PlanModel from "./PlanModel";

export default class PlansStore extends BaseItemStore<PlanModel> {}
